import React from 'react';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { analyticsChartTheme } from 'util/chartUtils';
import CardBox from '../../../../components/kea/CardBox';
import DashboardStub from '../../../../components/kea/DashboardStub';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function Conversion({ conversion }) {
  const t = useLocalizedMessage();
  const chartOptions = {
    legend: {
      display: false,
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      xAxes: [{
        stacked: false,
      }],
      yAxes: [{
        stacked: false,
        ticks: {
          beginAtZero: true,
        },
      }],
    },
  };

  function prepareData(data) {
    return {
      labels: [t('recs.dashboard.conversion.axis')],
      datasets: [
        {
          label: t('ui.recs.dashboard.conversion.didnTUseRecommendations'),
          backgroundColor: analyticsChartTheme.clickRateFill,
          data: [data.noRecs.rate],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        }, {
          label: t('ui.recs.dashboard.conversion.usedRecommendations'),
          backgroundColor: analyticsChartTheme.brand,
          data: [data.recs.rate],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        },
      ],
    };
  }

  if (conversion.error) {
    return (
      <CardBox header={t('recs.dashboard.conversion.title')} styleName="recs-dashboard-card">
        <DashboardStub />
      </CardBox>
    );
  }
  const chartData = prepareData(conversion);

  return (
    <CardBox header={t('recs.dashboard.conversion.title')} styleName="recs-dashboard-card">
      <div className="row">
        <div className="col-6">
          <Bar data={chartData} options={chartOptions} height={240} />
        </div>
        <div className="col-6">
          <p>
            <IntlMessages id="ui.recs.dashboard.conversion.conversionOfVisitorsWhoUsedRecommendationsIs" />
            <br />
            {conversion.ratio}
            {' '}
            <IntlMessages id="ui.recs.dashboard.conversion.timesHigherThan" />
            <br />
            <IntlMessages id="ui.recs.dashboard.conversion.conversionOfOtherInterestedVisitors" />
            <br />
          </p>
        </div>
      </div>

    </CardBox>
  );
}

Conversion.propTypes = {
  conversion: PropTypes.shape({
    recs: PropTypes.shape({ rate: PropTypes.any }),
    noRecs: PropTypes.shape({ rate: PropTypes.any }),
    ratio: PropTypes.any,
    error: PropTypes.any,
  }).isRequired,
};

export default Conversion;
